<template>
  <div class="container" :class="[isShowMergeNav==1?'mergeIndex':'']">
    <div class="care_top">
      <img src="../../assets/img/bg_02.png" alt />
      <div class="care_top_content">
        <div class="care_count">
          <span>{{cares.count}}</span>
          <p v-if="m_home_care_number" v-html="m_home_care_number">关怀次数</p>
        </div>
        <div class="banner">
          <router-link :to="{ path: '/my/welfare' }">
            <img src="../../assets/img/icon_01.png" alt class="welfare" />
            <span>我的福利</span>
          </router-link>
          <a href="javascript:;" @click="toBirthdayList" v-if="birthday_button">
            <img src="../../assets/img/icon_02.png" alt class="birth" />
            <span>生日贴士</span>
          </a>

          <router-link :to="{ path: '/profile' }">
            <img src="../../assets/img/profile.png" alt class="activity" />
            <span class="activity">个人中心</span>
          </router-link>

          <router-link :to="{ path: '/help' }">
            <img src="../../assets/img/icon_04.png" alt class="help" />
            <span>帮助中心</span>
          </router-link>
        </div>
      </div>
    </div>
    <!--关怀信息-->
    <div class="ghMessages">
      <div class="ghTitle">
        <h2>{{m_home_care_title}}</h2>
        <router-link class="moreMsg" :to="{ path: '/my/cards' }" v-if="messageInfoList.length > 0">
          <span>更多</span>
          <i class="moreGhMsg"></i>
        </router-link>
      </div>
      <ul class="ghm-list" v-if="messageInfoList.length > 0">
        <li class="ghmlist" v-for=" message in messageInfoList">
          <a class="cardUrl" :href="message.url">
            <div class="ghmLeft">
              <img :src="message.pic" />
            </div>
            <div class="ghmRight flex1">
              <h2>{{message.sceneName}}</h2>
              <div class="wel-desc">{{message.brief}}</div>
              <div class="wel-button" v-if="message.welfareCategory==3">
                <i class="icon-gift"></i>
                <span class="fuli-status">积分已到账</span>
              </div>
              <div class="wel-button" v-else>
                <i
                  class="icon-gift"
                  v-if="message.status==6 || message.status==1 || message.status==3"
                ></i>
                <span class="fuli-status" v-if="message.status==6">福利已过期</span>
                <span class="fuli-status" v-if="message.status==1">福利已领取</span>
                <span class="fuli-status" v-if="message.status==3">福利未领取</span>
              </div>
            </div>
          </a>
        </li>
      </ul>
      <ul class="ghm-list" v-if="caretipsNull">
        <li class="ghmlist">
          <a class="cardUrl" :href="cardUrl">
            <div class="ghmLeft">
              <img src="../../assets/img/msg_null.jpg" />
            </div>
            <div class="ghmRight flex1">
              <h2>欢迎使用乐关怀</h2>
              <div class="wel-desc">公司关怀新姿势，赶紧学起来！</div>
            </div>
          </a>
        </li>
      </ul>
    </div>
    <!--生日贴士-->
    <div class="birthday ghMessages" v-if="birthday_block_show">
      <div class="ghTitle">
        <h2>生日贴士</h2>
        <router-link
          class="moreMsg"
          v-if="getUserInfo"
          :to="{path: '/birthday/list', query:{corpId: this.currentCorpId}}"
        >
          <span>更多</span>
          <i class="moreGhMsg"></i>
        </router-link>
      </div>
      <div class="birthday-content">
        <div class="colleague-birthday" @click="toBoard()">
          <div class="text" v-if="homeBirthdayBean && homeBirthdayBean.weekBirthdayUserCount >0">
            <p class="first">本周生日同事</p>
            <p class="second">{{homeBirthdayBean.weekBirthdayUserCount}}位</p>

            <p class="three">
              去送祝福
              <i class="moreGhMsg"></i>
            </p>
          </div>
          <div class="text" v-if="homeBirthdayBean && homeBirthdayBean.weekBirthdayUserCount ===0">
            <p class="no-body-first">本周生日同事</p>
            <p class="no-body-second">还没出现哦</p>
          </div>
          <!--这个判定毫无意义-->
          <div class="text" v-if="homeBirthdayBean  === null">
            <p class="no-body-first">本周生日同事</p>
            <p class="no-body-second">还没出现哦</p>
          </div>
          <div class="cake-img">
            <img src="../../assets/img/birthday-cake.png" alt />
          </div>
        </div>
        <div class="my-birthday" @click="toPersonal()">
          <p v-if="homeBirthdayBean && homeBirthdayBean.nextBirthdayDays == 0" class="left">
            <i class="cake-icon"></i>生日快乐哟！
          </p>
          <p v-else class="left">
            <i class="cake-icon"></i>
            距我生日还有{{(homeBirthdayBean === null ? null : homeBirthdayBean.nextBirthdayDays) === null ? '***' : homeBirthdayBean.nextBirthdayDays}}天
          </p>

          <p class="right" v-if="homeBirthdayBean && homeBirthdayBean.wishCount<= 0">
            快去看看吧
            <i class="moreGhMsg"></i>
          </p>
          <p class="right" v-if="homeBirthdayBean === null">
            快去看看吧
            <i class="moreGhMsg"></i>
          </p>
          <p class="right" v-if="homeBirthdayBean && homeBirthdayBean.wishCount > 0">
            收到{{homeBirthdayBean.wishCount}}条祝福
            <i v-if="homeBirthdayBean.tips" class="red-spot"></i>
            <i class="moreGhMsg"></i>
          </p>
        </div>
      </div>
    </div>
    <template v-if="isShowMergeNav==1">
      <mergeMenu></mergeMenu>
    </template>
    <home :ishome="1"></home>
  </div>
</template>
<script>
import aghm from "../../api/aghm.js";
import { mapGetters, mapActions } from "vuex";
import mergeMenu from "../common/mergeNav";
import Cookies from "js-cookie";
import home from "../common/home.vue";

export default {
  data() {
    return {
      messageInfoList: [], //关怀消息
      cActivitys: [], //热门活动
      caretipsNull: false,
      homeBirthdayBean: "",
      cares: {
        company: "",
        count: "0"
      }
    };
  },
  components: {
    mergeMenu,
    home
  },
  computed: {
    ...mapGetters({
      getUserInfo: 'getUserInfo',
      userLoginFinish: "userLoginFinish",
      isShowMergeNav: "getisShowMergeNav",
      currentCorpId: "currentCorpId",
        customizeMHomeCareTitle:"getCustomizeMHomeCareTitle",
        customizeMHomeCareNumber:"getCustomizeMHomeCareNumber",
      corpCustomize:'getCorpCustomize'
    }),
    m_home_care_title(){
        return this.customizeMHomeCareTitle ||'近期关怀'
    },
    m_home_care_number(){
        return this.customizeMHomeCareNumber ||'关怀'+'次数'
    },
    cardUrl() {
        return process.env.VUE_APP_WELCOMEH5_URL
    },
    birthday_block_show(){
        return this.corpCustomize.birthday_block&&this.corpCustomize.birthday_block.value == 1 || !this.corpCustomize.birthday_block;
    },
    birthday_button(){
        return this.corpCustomize.birthday_button&&this.corpCustomize.birthday_button.value == 1 || !this.corpCustomize.birthday_button;
    },
  },
  watch: {
    userLoginFinish(cVal) {
      if (cVal) {
        this.initData();
      }
    }
  },
  methods: {
    initData() {
      //关怀首页list api
      document.title = document.title || '乐关怀'
      aghm.getCareList().then(
        res => {
          let data = res.data.body;
          console.log(data);
          this.homeBirthdayBean = data.homeBirthdayBean;
          this.messageInfoList = data.messageInfoList;
          this.cActivitys = data.cActivitys;
          this.cares.company = data.abbName;
          this.cares.count = data.caresCount;
          if (this.messageInfoList.length <= 0) {
            this.caretipsNull = true;
          } else {
            this.caretipsNull = false;
          }
        },
        error => {
          console.log("error");
        }
      );
    },
    //      todo  当有人过生日时，跳转到当周生日列表，没有人过生日，跳转到全部生日列表
    toBoard: function() {
      if (this.homeBirthdayBean) {
        if (this.homeBirthdayBean.weekBirthdayUserCount > 0) {
          this.$router.push({
            path: "/birthday/board",
            query: {
              corpId: this.currentCorpId
            }
          });
        } else {
          this.$router.push({
            path: "/birthday/list",
            query: {
              corpId: this.currentCorpId
            }
          });
        }
      }
    },
    toPersonal: function() {
      this.$router.push({
        path: "/birthday/personal",
        query: {
          corpId: this.currentCorpId
        }
      });
    },
    toBirthdayList() {
      this.$store.dispatch("setSearchParams", null);
      this.$router.push({
        name: "birthdayList",
        query: {
          corpId: this.currentCorpId
        }
      });
    }
  },
  mounted() {
    this.initData();
  }
};
</script>